/*
Thinners, Solvents and Catalysts
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Thinners, Solvents and Catalysts'
const id = 'sxShQUVEgbNzCPBG6Lcl'

export default {
  name,
  id,
  filters,
  headers,
  form
}
